<template>
    <b-container fluid class="overview">
        <h1 class="text-left">{{ $t('menuItemProfiles') }}</h1>
        <br />
        <div class="row">
            <!-- Search field -->
            <search-box
                id="searchProfiles"
                @input="$_onInput"
                :info="$t('searchInfo')"
                :autofocus="true"
                :value="searchText"
                :saveInState="true"
            >
            </search-box>
            <b-link class="px-1 pt-2" @click="$_clearFilters()">
                {{ $t('clearFilter') }}
            </b-link>
        </div>
        <!-- Ondergrond profielen -->
        <div>
            <b-table
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoadedBase"
                @row-clicked="$_onDetailsBase"
                :tbody-tr-class="$_rowClass"
                :items="filteredRecordsBase"
                :fields="fieldsBase"
                :sort-by.sync="sortByBase"
                :sort-desc.sync="sortDescBase"
                sort-icon-left
            >
            </b-table>
        </div>
        <!-- No content for Ondergrond profielen overview -->
        <div v-show="noDataBase" class="col-md-12">
            <span>{{ $t('profileNonePresentBase') }}</span>
        </div>
        <br />
        <!-- Theme and storage layer profiles -->
        <div>
            <b-table
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoadedTheme"
                @row-clicked="$_onDetailsTheme"
                :tbody-tr-class="$_rowClass"
                :items="filteredRecordsTheme"
                :fields="fieldsTheme"
                :sort-by.sync="sortByApi"
                :sort-desc.sync="sortDescTheme"
                sort-icon-left
            >
            </b-table>
        </div>
        <!-- No content for Theme and storage layer profiles overview -->
        <div v-show="noDataTheme" class="col-md-12">
            <span>{{ $t('profileNonePresentTheme') }}</span>
        </div>
        <br />
        <!-- Api profiles -->
        <div v-if="hasAnyApiLicense">
            <b-table
                striped
                hover
                small
                outlined
                bordered
                v-show="dataLoadedApi"
                @row-clicked="$_onDetailsApi"
                :tbody-tr-class="$_rowClass"
                :items="filteredRecordsApis"
                :fields="fieldsApi"
                :sort-by.sync="sortByTheme"
                :sort-desc.sync="sortDescApi"
                sort-icon-left
            >
            </b-table>
        </div>
        <!-- No content for Api profiles overview -->
        <div v-show="noDataApi" class="col-md-12">
            <span>{{ $t('profileNonePresentApi') }}</span>
        </div>
        <router-links-footer :routerLinks="routerLinks" />
    </b-container>
</template>

<script>
    import SearchBox from '../../components/SearchBox.vue';
    import RouterLinksFooter from '../../components/dashboard/RouterLinksFooter.vue';
    import { nprogress } from '../../services/utilities';
    import { PROFILE_TYPE } from '../../constants';
    import { mapState } from 'vuex';

    export default {
        name: 'ProfilesOverview',

        components: {
            'search-box': SearchBox,
            'router-links-footer': RouterLinksFooter
        },

        data: function () {
            return {
                sortByBase: 'name',
                sortDescBase: false,
                sortByTheme: 'name',
                sortDescTheme: false,
                sortByApi: 'name',
                sortDescApi: false,
                fieldsBase: [
                    {
                        key: 'name',
                        label: this.$t('labelProfileBase'),
                        sortable: true,
                        thStyle: { border: 0 }
                    }
                ],
                fieldsTheme: [
                    {
                        key: 'name',
                        label: this.$t('labelProfilesTheme'),
                        sortable: true,
                        thStyle: { border: 0 }
                    }
                ],
                fieldsApi: [
                    {
                        key: 'name',
                        label: this.$t('labelProfileNameApi'),
                        sortable: true,
                        thStyle: { border: 0 }
                    }
                ],
                recordsBase: [],
                recordsTheme: [],
                recordsApi: [],
                searchText: '',
                isResolvedBase: false,
                isResolvedTheme: false,
                isResolvedApi: false
            };
        },

        computed: {
            ...mapState(['hasAnyApiLicense']),
            dataLoadedBase() {
                return this.recordsBase.length > 0;
            },
            noDataBase() {
                return (
                    this.isResolvedBase &&
                    this.recordsBase &&
                    this.recordsBase.length === 0
                );
            },
            dataLoadedTheme() {
                return this.recordsTheme.length > 0;
            },
            noDataTheme() {
                return (
                    this.isResolvedTheme &&
                    this.recordsTheme &&
                    this.recordsTheme.length === 0
                );
            },
            noDataApi() {
                return (
                    this.isResolvedApi &&
                    this.hasAnyApiLicense &&
                    this.recordsApi &&
                    this.recordsApi.length === 0
                );
            },
            dataLoadedApi() {
                return this.recordsApi.length > 0;
            },
            filteredRecordsBase() {
                let records = this.recordsBase;
                // filter records on username
                if (this.searchText && this.searchText.length > 0) {
                    const tokens = this.searchText.toLowerCase();
                    records = records.filter((record) => {
                        return record.name.toLowerCase().includes(tokens);
                    });
                }
                return records;
            },
            filteredRecordsTheme() {
                let records = this.recordsTheme;
                // filter records on username
                if (this.searchText && this.searchText.length > 0) {
                    const tokens = this.searchText.toLowerCase();
                    records = records.filter((record) => {
                        return record.name.toLowerCase().includes(tokens);
                    });
                }
                return records;
            },
            filteredRecordsApis() {
                let records = this.recordsApi;
                // filter records on username
                if (this.searchText && this.searchText.length > 0) {
                    const tokens = this.searchText.toLowerCase();
                    records = records.filter((record) => {
                        return record.name.toLowerCase().includes(tokens);
                    });
                }
                return records;
            },
            routerLinks() {
                const routerLinks = [
                    {
                        name: 'profileBaseLayerDetailNew',
                        title: this.$t('menuItemNewBaseLayer')
                    },
                    {
                        name: 'profilesThemeFeedbackDetailNew',
                        title: this.$t('menuItemNewThemeFeedback')
                    }
                ];
                if (this.hasAnyApiLicense) {
                    routerLinks.push({
                        name: 'profilesApiDetailNew',
                        title: this.$t('menuItemNewApiProfile')
                    });
                }
                return routerLinks;
            }
        },

        async beforeCreate() {
            nprogress.start();
            // Only ondergrond profiles with id (profile_type_id) == 1
            await this.$store
                .dispatch('useApiData', {
                    name: 'GetProfileOverview',
                    parameters: { profileTypeId: PROFILE_TYPE.BASELAYER }
                })
                .then((result) => {
                    this.recordsBase = result.data;
                    this.isResolvedBase = true;
                    nprogress.done();
                });
            // Only theme and storage layer profiles with id (profile_type_id) == 2
            await this.$store
                .dispatch('useApiData', {
                    name: 'GetProfileOverview',
                    parameters: { profileTypeId: PROFILE_TYPE.THEME_FEEDBACK }
                })
                .then((result) => {
                    this.recordsTheme = result.data;
                    this.isResolvedTheme = true;
                });
            // Only theme and storage layer profiles with id (profile_type_id) == 3
            await this.$store
                .dispatch('useApiData', {
                    name: 'GetProfileOverview',
                    parameters: { profileTypeId: PROFILE_TYPE.API }
                })
                .then((result) => {
                    this.recordsApi = result.data;
                    this.isResolvedApi = true;
                });
        },

        methods: {
            $_onDetailsBase(record) {
                this.$router.push({
                    path: `/dashboard/profilesBaseLayer/detail/${record.id}`
                });
            },
            $_onDetailsTheme(record) {
                this.$router.push({
                    path: `/dashboard/profilesThemeFeedback/detail/${record.id}`
                });
            },
            $_onInput(searchText) {
                this.searchText = searchText;
            },
            $_onDetailsApi(record) {
                this.$router.push({
                    path: `/dashboard/profilesApi/detail/${record.id}`
                });
            },
            $_rowClass() {
                return 'tablerow';
            },
            $_clearFilters() {
                this.$_onInput('');
            }
        }
    };
</script>
